import { Component, EventEmitter, OnInit, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { EmailValidator, FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as serv from '../../services/index'

import {SalesOfficeDropdownComponent} from '../../components/DomainData/SalesOfficeDropdown.component';

//constants
import { Constants }         from '../../constants/Constants';

//baseclasses
import { BaseEditComponent }         from '../../baseclasses/BaseEdit.component';

@Component({
  selector: 'my-logmessage-detail',
  templateUrl: './LogMessageDetail.component.html'
})
export class LogMessageDetailComponent {

    public displayDialog: boolean;

    @Input() public logMessage: ent.LogMessage;

    
    constructor() 
    { 

    }


    ngOnInit(): void {

        

    }

    onHide(){
        this.displayDialog = false;
    }

    onOKClick(event: any){
        
        this.displayDialog = false;

    }

    

}